import { render } from "./fhtj.vue?vue&type=template&id=37073c07&scoped=true&ts=true"
import script from "./fhtj.vue?vue&type=script&lang=ts"
export * from "./fhtj.vue?vue&type=script&lang=ts"

import "./fhtj.vue?vue&type=style&index=0&id=37073c07&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37073c07"]])

export default __exports__